import { Empty, Typography } from "antd";
import { Commson } from "@/assets";
import { useEffect } from "react";
import NProgress from "nprogress";

const ComingSoon = () => {
  useEffect(() => {
    NProgress.done();
  }, []);
  return (
    <div className="flex justify-center items-center min-h-[calc(100vh-200px)] comingSoonCass">
      <Empty
        image={Commson}
        styles={{ image: { height: 280, marginBottom: 0 } }}
        description={
          <Typography.Text className="text-[26px] font-semibold leading-0 text-[#5F5F5F]">
            Coming soon
          </Typography.Text>
        }
      ></Empty>
    </div>
  );
};

export default ComingSoon;
